<template>
	<rmp-sign-in-form-base :title="tc('titles.forgotPassword')">
		<v-responsive v-if="mode === AuthPageModeType.INITIAL">
			<v-form :readonly="formSaving || formReadonly" :disabled="formDisabled"
					@submit.prevent="submit"
					ref="form" v-model="formValid">

				<rmp-text tag="span" type="body-large" class="d-block" :color="colors.grey.darken1">
					Для восстановления доступа к аккаунту сотрудника укажите его адрес электронной почты.
				</rmp-text>
				
				<rmp-text tag="span" type="body-large" class="d-block" :color="colors.grey.darken1">
					Для восстановления доступа к мастер-аккаунту перейдите в
					<rmp-link blank inline :to="{ name: RouteNames.MASTER_ACCOUNT_ACCESS }"
							  text="раздел регистрации организации"/>
					.
				</rmp-text>
				<v-row>
					<v-col class="pb-2">
						<rmp-text-field autocomplete="email"
										required
										name="email"
										:placeholder="tc('fields.email.placeholder')"
										:label="tc('fields.email.label')"
										class="mt-4"
										:rules="validation.email"
										v-model="email">
						</rmp-text-field>
					</v-col>
				</v-row>
				<v-row class="flex-column">
					<v-col class="pt-0">
						<rmp-btn class="rmp-btn mb-4"
								 type="submit"
								 color="primary"
								 :loading="formSaving"
								 :disabled="!formValid"
								 block>
							{{ tc("buttons.resetPassword") }}
						</rmp-btn>
						<rmp-btn v-if="mode === AuthPageModeType.INITIAL" block outlined color="secondary"
								 :to="{ name: RouteNames.SIGN_IN }">
							{{ tc("buttons.toSignIn") }}
						</rmp-btn>
					</v-col>
				</v-row>
			</v-form>
		</v-responsive>

		<div v-if="mode === AuthPageModeType.SUCCESS" class="d-flex flex-column">
			<rmp-text tag="span" type="body-large" :color="colors.grey.darken1">
				{{ tc("common.forgotPasswordFormText.successText.part1") }}
				<span class="secondary--text">{{ email }}</span>
				{{ tc("common.forgotPasswordFormText.successText.part2") }}
			</rmp-text>

			<rmp-btn class="my-4" block outlined color="secondary" :to="{ name: RouteNames.SIGN_IN }">
				{{ tc("buttons.toSignIn") }}
			</rmp-btn>
			<rmp-btn outlined block :disabled="!!timer" @click="handleSave">
				{{ $vuetify.breakpoint.smOnly ? tc("buttons.resendInstructions.short") : tc("buttons.resendInstructions.long") }}
			</rmp-btn>

			<rmp-text tag="span" type="body-large" :color="colors.grey.darken1" class="d-block text-center mt-10" :style="!!timer ? '' : 'visibility: hidden'">
				<span>{{ tc("common.resendInstructionsAgainAfter") }}</span>
				<span class="primary--text ml-3" style="width: 25px">{{ timer + tc("common.seconds") }}</span>
			</rmp-text>
		</div>
	</rmp-sign-in-form-base>
</template>

<script setup lang="ts">
import RmpText from "@rmp/core/components/typography/RmpText.vue";
import RmpBtn from "@rmp/core/components/buttons/RmpBtn.vue";
import RmpTextField from "@rmp/core/components/fields/RmpTextField.vue";
import { RouteNames } from "@rmp/id/router/routes";
import { prepareEmailRule, requiredRule } from "@rmp/core/utils/validation";
import RmpSignInFormBase from "@rmp/core/components/form/RmpSignInFormBase.vue";
import { useI18n } from "vue-i18n-composable";
import { useRoute } from "vue-router/composables";
import { useColors } from "@rmp/core/composables/useColors";
import { storeToRefs } from "pinia";
import { ref } from "vue";
import { useForm } from "@rmp/core/composables/useForm";
import { usePage } from "@rmp/core/composables/usePage";
import { useForgotPasswordStore } from "@rmp/id/stores/forgotPassword";
import { AuthPageModeType } from "@rmp/core/types/authorization/authPageModeType";
import RmpLink from "@rmp/core/components/common/RmpLink.vue";

const { tc } = useI18n();
const route = useRoute();
const { colors } = useColors();

const useStore = useForgotPasswordStore;
const store = useStore();
const { save } = store;
const { mode, email } = storeToRefs(store);

const timer = ref(0);

const handleSave = async () => {
	await save();

	if(mode!.value === AuthPageModeType.SUCCESS)
		startTimer();
};
const startTimer = () => {
	if(timer.value > 0) return;
	
	timer.value = 60;
	
	const interval = setInterval(() => {
		timer.value--;
		if(timer.value <= 0) clearInterval(interval);
	}, 1000);
};

const validation = {
	email: [requiredRule(), prepareEmailRule()]
};

const {
	form,
	formStateLoading,
	formReadonly,
	formDisabled,
	formSaving,
	formValid,
	submit
} = useForm({ useStore }, true);

const { initialized, loading } = usePage({ useStore });
</script>
